module.exports = __webpack_public_path__ + "media/images/new-ui-images/request-icon-8643c8b084073b7e8363d5aff8a1738a.svg";